export const C = {
  navy: '#1D3557',
  gold: '#C9A227',
  dark: '#1a2332',
  surface: '#1f2b3d',
  green: '#4ECDC4',
  red: '#FF6B6B',
  text: '#ffffff',
  textMuted: 'rgba(255,255,255,0.55)',
  borderSoft: 'rgba(255,255,255,0.08)',
  borderPanel: 'rgba(255,255,255,0.12)',
  panel: 'rgba(255,255,255,0.04)',
  panelSoft: 'rgba(255,255,255,0.03)',
};

export const FONT = {
  body: 'Montserrat, Arial, sans-serif',
};

export const LAYOUT = {
  shell: {
    minHeight: '100vh',
    background: C.dark,
    color: C.text,
    fontFamily: FONT.body,
  },
  header: {
    padding: '20px 24px',
    borderBottom: `1px solid ${C.borderSoft}`,
  },
  main: {
    padding: 24,
  },
  panel: {
    maxWidth: 720,
    padding: 24,
    border: `1px solid ${C.borderPanel}`,
    borderRadius: 16,
    background: C.panel,
  },
  // Flattened: subPanel is now a section-spacer, not a glass surface. Modules
  // previously used this as a wrapper-with-frame; collapsing to a pure spacer
  // stops the page from reading as stacked glass panes. Explicit glass is still
  // available via LAYOUT.panel and the `.glass-panel*` utility classes.
  subPanel: {
    marginTop: 20,
  },
};
